import React from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import { convertUTCDateToLocalDate, FormatDateUsingTimeZone } from "../../Utility";

const Export = ({data, comments}) => {
  return (
    <div id="export">
      {Object.entries(data).map((array) => (
        <div className="mb-5" key={array[0]}>
          <div className="" style={{ fontWeight: "bold", fontSize: "18px" }}>
            Section: {array[0]}
          </div>
          <div className="d-flex flex-wrap">
            {array[1].map((i, key) => (
              <div className="me-2 mb-3 mt-2 form-field-export" key={key}>
                <label>{i.shortLabel}</label>
                <div className="info">{i.textValue}</div>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div>
        <div className="" style={{ fontWeight: "bold", fontSize: "18px" }}>
          Comments
        </div>
        {comments.map((comment, index) => (
          <div className="form-group row mb-2 border-bottom" key={index}>
            <label
              htmlFor="comment"
              style={{ fontWeight: "semi-bold" }}
              className="col-sm-4 col-form-label"
            >
              Comment:
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                readOnly
                className="form-control-plaintext"
                value={comment.comment}
              />
            </div>
            <label
              htmlFor="refecenceSection"
              style={{ fontWeight: "semi-bold" }}
              className="col-sm-4 col-form-label"
            >
              Reference Section:
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                readOnly
                className="form-control-plaintext"
                value={comment.itemSectionLabel}
              />
            </div>
            <label
              htmlFor="referenceField"
              style={{ fontWeight: "semi-bold" }}
              className="col-sm-4 col-form-label"
            >
              Reference Field:
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                readOnly
                className="form-control-plaintext"
                value={comment.itemShortLabel}
              />
            </div>
            <label
              htmlFor="highlightedText"
              style={{ fontWeight: "semi-bold" }}
              className="col-sm-4 col-form-label"
            >
              Reference Text:
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                readOnly
                className="form-control-plaintext"
                value={comment.highlightedText}
              />
            </div>

            <label
              htmlFor="createdOn"
              style={{ fontWeight: "semi-bold" }}
              className="col-sm-4 col-form-label"
            >
              Created On:
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                readOnly
                className="form-control-plaintext"
                value={FormatDateUsingTimeZone(
                  convertUTCDateToLocalDate(comment.createdOn)
                )}
              />
            </div>
            <label
              htmlFor="userCommented"
              style={{ fontWeight: "semi-bold" }}
              className="col-sm-4 col-form-label"
            >
              User Commented:
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                readOnly
                className="form-control-plaintext"
                value={comment.userName}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Export